import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
export default function TheSavoryStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}